export enum IDigitalProductVisibility {
    Draft = 1,
    Published = 2,
    Archived = 3
}
